export const DEFAULT_API = process.env.REACT_APP_API_URL || 'https://api-easycompta.fewnu.app/api';
export const DEFAULT_API_IMAGE = process.env.REACT_APP_API_IMG_URL || 'https://api-easycompta.fewnu.app';
export const DEFAULT_BACKEND = process.env.REACT_APP_BACKEND_URL || (DEFAULT_API ? DEFAULT_API.replace(/\/api\/?$/, '') : 'https://api-easycompta.fewnu.app');

// USER ROUTE
export const ACTIVATION_API_ROUTE = `${DEFAULT_BACKEND}/auth/users/activation/`;
export const REGISTER_API_ROUTE = `${DEFAULT_BACKEND}/auth/users/`;
export const LOGIN_API_ROUTE = `${DEFAULT_BACKEND}/auth/jwt/create/`;
export const RESET_PASSWORD_API_ROUTE = `${DEFAULT_BACKEND}/auth/users/reset_password/`;
export const RESET_PASSWORD_CONFIRM_API_ROUTE = `${DEFAULT_BACKEND}/auth/users/reset_password_confirm/`;
export const GET_USER_ME_API_ROUTE = `${DEFAULT_BACKEND}/auth/users/me/`;

// RAG - Recherche de compte comptable
export const RECHERCHE_COMPTE_API_ROUTE = `${DEFAULT_API}/comptable/rechercher/`;
export const SUGGESTIONS_INTELLIGENTES_API_ROUTE = `${DEFAULT_API}/comptable/suggestions/`;
export const INITIALISER_RAG_API_ROUTE = `${DEFAULT_API}/comptable/initialiser/`;


// Créances
export const GET_ALL_CREANCES_API_ROUTE = `${DEFAULT_API}/v1/creances/`;
export const GET_ALL_CREANCES_BY_USER_API_ROUTE = `${DEFAULT_API}/v1/creances/`;
export const ADD_CREANCE_API_ROUTE = `${DEFAULT_API}/v1/creances/`;
export const UPDATE_CREANCE_API_ROUTE = `${DEFAULT_API}/v1/creances/`;
export const DELETE_CREANCE_API_ROUTE = `${DEFAULT_API}/v1/creances/`;
export const PAIEMENT_CREANCE_API_ROUTE = `${DEFAULT_API}/v1/paiement-creance/`;
export const HISTORIQUE_PAIEMENT_CREANCE_API_ROUTE = `${DEFAULT_API}/v1/paiement-creance/`;

// Dettes
export const GET_ALL_DETTES_API_ROUTE = `${DEFAULT_API}/v1/dettes/`;
export const GET_ALL_DETTES_BY_USER_API_ROUTE = `${DEFAULT_API}/v1/dettes/`;
export const ADD_DETTE_API_ROUTE = `${DEFAULT_API}/v1/dettes/`;
export const UPDATE_DETTE_API_ROUTE = `${DEFAULT_API}/v1/dettes/`;
export const DELETE_DETTE_API_ROUTE = `${DEFAULT_API}/v1/dettes/`;
export const PAIEMENT_DETTE_API_ROUTE = `${DEFAULT_API}/v1/paiement-dette/`;
export const HISTORIQUE_PAIEMENT_DETTE_API_ROUTE = `${DEFAULT_API}/v1/paiement-dette/`;

export const UPDATE_USER_DATA = `${DEFAULT_API}/v1/users/`;
export const GET_USER_DATA = `${DEFAULT_API}/v1/users/`;
export const GET_USER_BY_ID_DATA = `${DEFAULT_API}/v1/users/<int:id>`;
export const REFRESH_TOKEN = `${DEFAULT_BACKEND}/auth/jwt/refresh/`;
export const GET_USER_API_ROUTE = `${DEFAULT_API}/v1/users/<int:id>`;
export const GET_USER_COLLABORATEUR_API_ROUTE = `${DEFAULT_API}/v1/user_collaborateur`;

// EASY SUITE SSO
export const SSO_VERIFY_AND_LOGIN_API_ROUTE = `${DEFAULT_API}/v1/sso/verify-and-login/`;

// AUTHENTIFICATION MULTIFACTEUR (MFA / 2FA)
export const MFA_STATUS_API_ROUTE = `${DEFAULT_API}/v1/auth/mfa/status/`;
export const MFA_SETUP_API_ROUTE = `${DEFAULT_API}/v1/auth/mfa/setup/`;
export const MFA_ENABLE_API_ROUTE = `${DEFAULT_API}/v1/auth/mfa/enable/`;
export const MFA_DISABLE_API_ROUTE = `${DEFAULT_API}/v1/auth/mfa/disable/`;
export const MFA_REGENERATE_BACKUP_CODES_API_ROUTE = `${DEFAULT_API}/v1/auth/mfa/regenerate-backup-codes/`;
export const MFA_VERIFY_LOGIN_API_ROUTE = `${DEFAULT_API}/v1/auth/mfa/verify/`;
export const MFA_SEND_EMAIL_CODE_API_ROUTE = `${DEFAULT_API}/v1/auth/mfa/send-email-code/`;

// DOSSIER CLIENT ROUTE
export const ADD_DOSSIER_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/dossiers-client/`;
export const GET_DOSSIER_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/dossiers-client/`;
export const UPDATE_DOSSIER_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/dossiers-client/`;
export const DELETE_DOSSIER_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/dossiers-client/`;

// Calculate the compte des resultats (Incomes statements)
export const GET_THE_COMPTE_RESULTATS_API_ROUTE = `${DEFAULT_API}/v1/compte-resultat/`;

// FISCALITE : obligations fiscales & sociales
export const GET_OBLIGATIONS_FISCALES_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/obligations/`;
export const ADD_OBLIGATION_FISCALE_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/obligations/`;
export const UPDATE_OBLIGATION_FISCALE_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/obligations/`;
export const DELETE_OBLIGATION_FISCALE_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/obligations/`;
export const PAYER_OBLIGATION_FISCALE_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/obligations/`; // + <id>/payer/
export const DECLARER_OBLIGATION_FISCALE_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/obligations/`; // + <id>/declarer/
export const SEED_OBLIGATIONS_FISCALES_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/obligations/seed/`;
export const PARAMETRES_FISCAUX_API_ROUTE = `${DEFAULT_API}/v1/fiscalite/parametres/`;

// compte_paiement
export const ADD_COMPTE_PAIEMENT_API_ROUTE = `${DEFAULT_API}/v1/compte_paiement/`;
export const GET_COMPTE_PAIEMENT_API_ROUTE = `${DEFAULT_API}/v1/compte_paiement/`;
export const UPDATE_COMPTE_PAIEMENT_API_ROUTE = `${DEFAULT_API}/v1/compte_paiement/`;
export const DELETE_COMPTE_PAIEMENT_API_ROUTE = `${DEFAULT_API}/v1/compte_paiement/`;

// operateurs
export const GET_OPERATEURS_API_ROUTE = `${DEFAULT_API}/v1/operateurs/`;
export const ADD_OPERATEUR_API_ROUTE = `${DEFAULT_API}/v1/operateurs/`;
export const GET_OPERATEUR_API_ROUTE = `${DEFAULT_API}/v1/operateurs/`;
export const UPDATE_OPERATEUR_API_ROUTE = `${DEFAULT_API}/v1/operateurs/`;
export const DELETE_OPERATEUR_API_ROUTE = `${DEFAULT_API}/v1/operateurs/`;

// clients
export const ADD_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/clients/`;
export const GET_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/clients/`;
export const UPDATE_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/clients/`;
export const DELETE_CLIENT_API_ROUTE = `${DEFAULT_API}/v1/clients/`;

// fournisseurs
export const ADD_FOURNISSEUR_API_ROUTE = `${DEFAULT_API}/v1/fournisseurs/`;
export const GET_FOURNISSEUR_API_ROUTE = `${DEFAULT_API}/v1/fournisseurs/`;
export const UPDATE_FOURNISSEUR_API_ROUTE = `${DEFAULT_API}/v1/fournisseurs/`;
export const DELETE_FOURNISSEUR_API_ROUTE = `${DEFAULT_API}/v1/fournisseurs/`;

// Depenses
export const ADD_DEPENSES_API_ROUTE = `${DEFAULT_API}/v1/sorties/`;
export const GET_DEPENSES_API_ROUTE = `${DEFAULT_API}/v1/sorties/`;
export const UPDATE_DEPENSES_API_ROUTE = `${DEFAULT_API}/v1/sorties/`;
export const DELETE_DEPENSES_API_ROUTE = `${DEFAULT_API}/v1/sorties/`;

// vente
export const ADD_VENTE_API_ROUTE = `${DEFAULT_API}/v1/entrees/`;
export const GET_VENTE_API_ROUTE = `${DEFAULT_API}/v1/entrees/`;
export const UPDATE_VENTE_API_ROUTE = `${DEFAULT_API}/v1/entrees/`;
export const DELETE_VENTE_API_ROUTE = `${DEFAULT_API}/v1/entrees/`;
export const ASSISTANT_IA_OPERATION_API_ROUTE = `${DEFAULT_API}/v1/assistant-ia/operation/`;

// Migration Odoo
export const ODOO_MIGRATION_IMPORT_API_ROUTE = `${DEFAULT_API}/v1/odoo-migration/import/`;
export const ODOO_MIGRATION_LOGS_API_ROUTE = `${DEFAULT_API}/v1/odoo-migration/logs/`;

// Produits
export const ADD_PRODUITS_API_ROUTE = `${DEFAULT_API}/v1/product/`;
export const GET_PRODUITS_API_ROUTE = `${DEFAULT_API}/v1/product/`;
export const UPDATE_PRODUITS_API_ROUTE = `${DEFAULT_API}/v1/product/`;
export const DELETE_PRODUITS_API_ROUTE = `${DEFAULT_API}/v1/product/`;

// routes all transactions
export const GET_ALL_TRANSACTIONS_API_ROUTE = `${DEFAULT_API}/v1/entrees-sorties/`;
export const GET_ONE_TRANSACTIONS_API_ROUTE = `${DEFAULT_API}/v1/entrees-sorties/`;
export const DELETE_ONE_TRANSACTIONS_API_ROUTE = `${DEFAULT_API}/v1/entrees-sorties/`;

// ocr facture
export const GET_ONE_OCR_API_ROUTE = `${DEFAULT_API}/v1/factures/`;
export const GET_OCR_API_ROUTE = `${DEFAULT_API}/v1/factures/`;
export const ADD_OCR_API_ROUTE = `${DEFAULT_API}/v1/extract_facture/`;

// Comptes Comptables
export const GET_COMPTES_CLASS = `${DEFAULT_API}/v1/classes/`;
export const GET_COMPTES_COMPT = `${DEFAULT_API}/v1/comptes/`;
export const GET_COMPTES_COMPT_DIV = `${DEFAULT_API}/v1/comptes-divisionnaires/`;

// cabinet - Collaborateur
export const ADD_COLLABORATEUR_API_ROUTE = `${DEFAULT_API}/v1/collaborateur/`;
export const GET_COLLABORATEUR_API_ROUTE = `${DEFAULT_API}/v1/collaborateur/`;
export const UPDATE_COLLABORATEUR_API_ROUTE = `${DEFAULT_API}/v1/collaborateur/`;
export const DELETE_COLLABORATEUR_API_ROUTE = `${DEFAULT_API}/v1/collaborateur/`;

// Roles
export const ADD_ROLE_API_ROUTE = `${DEFAULT_API}/v1/roles/`;
export const GET_ROLE_API_ROUTE = `${DEFAULT_API}/v1/roles/`;
export const ADD_PERMISSIONS_API_ROUTE = (id) =>
  `${DEFAULT_API}/v1/roles/${id}/permissions/`;
export const GET_PERMISSIONS_API_ROUTE = `${DEFAULT_API}/v1/roles/<int:id>/permissions/`;
export const UPDATE_ROLE_API_ROUTE = `${DEFAULT_API}/v1/roles/`;
export const DELETE_ROLE_API_ROUTE = `${DEFAULT_API}/v1/roles/`;

export const GET_EXPERTCOMPTABLE_DOSSIERS_API_ROUTE = `${DEFAULT_API}/v1/collaborateur/client_dossiers`;

// Facture-cabinet
export const ADD_FACTURE_CABINET_API_ROUTE = `${DEFAULT_API}/v1/facture-cabinet/`;
export const UPDATE_FACTURE_CABINET_API_ROUTE = `${DEFAULT_API}/v1/facture-cabinet/`;
export const DELETE_FACTURE_CABINET_API_ROUTE = `${DEFAULT_API}/v1/facture-cabinet/`;
export const GET_FACTURE_CABINET_API_ROUTE = `${DEFAULT_API}/v1/facture-cabinet/`;

// Facturation (factures & devis generes)
export const FACTURATION_API_ROUTE = `${DEFAULT_API}/v1/factures/`;

// Entreprise
export const GET_BALANCE_GENERAL = `${DEFAULT_API}/v1/balance/`;
export const GET_LIVRE_JOURNAL = `${DEFAULT_API}/v1/journal/`;
export const GET_Grand_Livre = `${DEFAULT_API}/v1/grand-livre/`;
export const GET_GRAND_LIVRE_TIERS = `${DEFAULT_API}/v1/grand-livre-tiers/`;
export const GET_BILAN_COMPTABLE = `${DEFAULT_API}/v1/bilan-comptable/`;
export const GET_ECRITURES_MANUELLES = `${DEFAULT_API}/v1/ecritures-manuelles/`;
export const ADD_ECRITURE_MANUELLE = `${DEFAULT_API}/v1/ecritures-manuelles/`;
export const ECRITURES_MULTILIGNES = `${DEFAULT_API}/v1/ecritures-multilignes/`;
export const IMPORT_ECRITURES = `${DEFAULT_API}/v1/ecritures-import/`;
export const CORRIGER_BILAN_COMPTABLE = `${DEFAULT_API}/v1/bilan-comptable/correction/`;
export const WORKFLOW_ECRITURE_MANUELLE = `${DEFAULT_API}/v1/ecritures-manuelles/`;
export const RECONSTRUCTION_COMPTABLE = `${DEFAULT_API}/v1/reconstruction-comptable/`;
export const CLEANUP_ORPHAN_ECRITURES = `${DEFAULT_API}/v1/cleanup-orphans/`;
export const GET_BILAN = `${DEFAULT_API}/v1/bilans/`;
export const GET_COMPTES_RESULTAT = `${DEFAULT_API}/v1/compte-resultat/`;
export const GET_BILAN_STRUCTURE = `${DEFAULT_API}/v1/bilan-structure/`;

// Cabinet
export const GET_BALANCE_GENERAL_CABINET = `${DEFAULT_API}/v1/balance_cabinet/`;
export const GET_LIVRE_JOURNAL_CABINET = `${DEFAULT_API}/v1/journal_cabinet/`;
export const GET_Grand_Livre_CABINET = `${DEFAULT_API}/v1/grand-livre_cabinet/`;
export const GET_BILAN_CABINET = `${DEFAULT_API}/v1/bilans/`;

// Codes comptables
export const GET_CODES_COMPTABLES = `${DEFAULT_API}/v1/codes-comptables/`;
export const GET_CODES = `${DEFAULT_API}/v1/codes/`;

// salaries
export const ADD_SALARIES_API_ROUTE = `${DEFAULT_API}/v1/salaries/`;
export const GET_SALARIES_API_ROUTE = `${DEFAULT_API}/v1/salaries/`;
export const UPDATE_SALARIES_API_ROUTE = `${DEFAULT_API}/v1/salaries/`;
export const DELETE_SALARIES_API_ROUTE = `${DEFAULT_API}/v1/salaries/`;

// Import file
export const CLIENT_FILE_API_ROUTE = `${DEFAULT_API}/v1/client_excel/`;
export const FOURNISSEUR_FILE_API_ROUTE = `${DEFAULT_API}/v1/fournisseurs_excel/`;
export const SALARIES_FILE_API_ROUTE = `${DEFAULT_API}/v1/salaries_excel/`;

// SAGE - Codes Journaux
export const ADD_CODEJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_spec/`;
export const GET_CODEJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_spec/`;
export const UPDATE_CODEJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_spec/`;
export const DELETE_CODEJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_spec/`;

// Livres Journaux
export const ADD_LIVREJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_date/`;
export const GET_LIVREJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_date/`;
export const UPDATE_LIVREJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_date/`;
export const DELETE_LIVREJOURNAUX_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_date/`;
export const ADD_LIVREJOURNAUX_PIECEJOINTE_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_filemodif/`;

// Ecritures comptables
export const ADD_ECRITURESCOMPTABLES_API_ROUTE = `${DEFAULT_API}/v1/ecriture_spec/`;
export const GET_ECRITURESCOMPTABLES_API_ROUTE = `${DEFAULT_API}/v1/ecriture_spec/`;
export const UPDATE_ECRITURESCOMPTABLES_API_ROUTE = `${DEFAULT_API}/v1/ecriture_spec/`;
export const DELETE_ECRITURESCOMPTABLES_API_ROUTE = `${DEFAULT_API}/v1/ecriture_spec/`;

// Ecritures par mois
export const GET_LIVREECRITURESByMonth_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_month/`;
export const GET_LIVREECRITURES_API_ROUTE = `${DEFAULT_API}/v1/livrejournal_total/`;
export const GET_TIERS_BYDOSSIER_API_ROUTE = `${DEFAULT_API}/v1/tiers/`;

export const ADD_PLAN_COMPTABLE_API_ROUTE = `${DEFAULT_API}/v1/plancomptable_bydossier/`;
export const UPDATE_PLAN_COMPTABLE_API_ROUTE = `${DEFAULT_API}/v1/plancomptable_bydossier/`;
export const DELETE_PLAN_COMPTABLE_API_ROUTE = `${DEFAULT_API}/v1/plancomptable_bydossier/`;

// Comptabilité
export const GET_GRANDLIVRE_GENERAL_API_ROUTE = `${DEFAULT_API}/v1/grandlivre_general/`;
export const GET_BALANCE_GENERAL_API_ROUTE = `${DEFAULT_API}/v1/balance_general/`;
export const GET_BALANCE_AUXILIAIRE_API_ROUTE = `${DEFAULT_API}/v1/balance_auxiliaire/`;
export const GET_BALANCE_AGEE_API_ROUTE = `${DEFAULT_API}/v1/balance_agee/`;
export const GET_BILAN_COMPTABLE_API_ROUTE = `${DEFAULT_API}/v1/bilan_comptable/`;

// OCR AI
export const ADD_FILE_OCR_API_ROUTE = `${DEFAULT_API}/ocr_savefile/`;
export const GET_FILE_OCR_API_ROUTE = `${DEFAULT_API}/ocr_savefile/`;
export const UPDATE_FILE_OCR_API_ROUTE = `${DEFAULT_API}/v1/ocr_savefile/`;
export const DELETE_FILE_OCR_API_ROUTE = `${DEFAULT_API}/v1/ocr_savefile/`;
export const GET_OCR_TO_EXTRACT = `${DEFAULT_API}/ocr_extraction/`;
export const OCR_BOT_START_API_ROUTE = `${DEFAULT_API}/ocr_bot/start/`;
export const OCR_BOT_MESSAGE_API_ROUTE = `${DEFAULT_API}/ocr_bot/`;

// GED & Pièces Comptables
export const PIECES_COMPTABLES_API_ROUTE = `${DEFAULT_API}/v1/pieces/`;
export const PIECES_COMPTABLES_STATS_API_ROUTE = `${DEFAULT_API}/v1/pieces/stats/`;
export const RAPPROCHEMENT_PIECES_API_ROUTE = `${DEFAULT_API}/v1/rapprochement-pieces/`;
export const RATTACHER_PIECE_API_ROUTE = `${DEFAULT_API}/v1/pieces/rattacher/`;
